import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
// import { PublicInterceptorIPS } from "../../../interceptors/PublicInterceptorIPS";

export const getImagenProducto = async (IdProducto) => {
    const result = await PrivateInterceptor(`Base/Global/productosSuministros/imagenSuministro/${IdProducto}`, 'GET');
    return result;

}

export const getProductos = async () => {
    const result = await PrivateInterceptor(`Base/Global/productosSuministros/`, 'GET');
    return result;

}

export const getInfoProducto = async(IdProducto) => {
    const result = await PrivateInterceptor(`Base/Global/productosSuministros/${IdProducto}`, 'GET');
    return result;
}

export const putInfoProducto = async(datos) =>{
    const result = await PrivateInterceptor(`Base/Global/productosSuministros/categorizacion`, 'PUT', datos);
    return result;
}

export const getProductosActivos = async() =>{
    const result = await PrivateInterceptor(`Base/Global/productosSuministros/productos/Activos`, 'GET')
    return result
}

export const getInventarioProducto = async(IdProducto)=>{
    const result = await PrivateInterceptor(`Base/Global/productosSuministros/Inventario/${IdProducto}`, 'GET')
    return result
} 

// export const getImagenProductoServer = async(CodigoProducto) =>{

//     const result = await PublicInterceptorIPS(`Imagenes/getFileBase64/${CodigoProducto}`, 'GET')
//     return result
// }